
<div class="btn-track chip d-inline-block px-2 py-1">
    <div class="d-flex flex-row align-items-center">
        <div class="typo-chip text-white px-2">{{ 'wap1_c_barcode_scanType' | translate }}</div>
        <img class="picto-small" src="../../../assets/images/231116/pictos/Type.svg" />
    </div>
</div>